import React from 'react';
import { Button } from 'react-bootstrap';

import blank1080 from
    '../../TwoD/Common/blank-1080x210.png';

// VARIANTS mirrors the Bootstrap-variant-by-faction map used in the
// source `ActionSelector.renderEndTurnContainer`. Preserved exactly so
// the button visual matches the in-picker copy that still ships for
// non-Desktop presets.
const VARIANTS = [
    null, 'deep', 'stem', 'hex', 'dread', 'honored', 'seed',
];

const DEFAULT_LABEL = 'End Turn';
const DEFAULT_TESTID_BASE = 'inline-end-turn';

// EndTurnButton — the action-done control that lives in the
// ActionWindow's yield slot. Extracted from
// ActionSelector.renderEndTurnContainer so it can be rendered at the
// ActionWindow level and stay visible across mode transitions (the
// original lived inside the swiper's render block, so it disappeared
// whenever ActionSelector returned the empty fragment for non-mid-turn
// statuses).
//
// It renders ONE of two state-honest affordances; the caller
// (ActionWindow) chooses which from the broadcast seat state:
//   - turn-level (TAKING_TURN mid-turn): label 'End Turn', default
//     handler fires api.clickEndTurn → the engine's unconditional
//     end_turn() (take_turn.next_button EndTurn branch).
//   - mid-action (juiced sub-states): label 'Skip' with onClick wired
//     to api.clickNext → the engine's skip_button → finish_action, the
//     SAME wire shape BigButton2's legacy Skip has always sent. The
//     mid-action click was ALWAYS a skip on that path; only the label
//     used to lie ('End Turn'). clickNext is also race-safe vs
//     clickEndTurn here: if a pipelined patch advances the seat into a
//     turn-level status before the click lands, clickNext advances
//     benignly where clickEndTurn would unexpectedly yield the turn.
//
// Both variants share this primitive — the Bootstrap faction `variant`,
// the blank1080 invisible click target, the action-done-{container,
// button} chrome — so the slot looks identical; only label, testid,
// and handler differ. `testIdBase` keeps the two variants
// distinguishable in tests; it defaults to the historical
// `inline-end-turn-{container,button}` ids so existing targets work
// unchanged.
export function EndTurnButton(props) {
    const {
        gamePlayerData, api, onClick, extraClass, label, testIdBase,
    } = props;

    const resolvedLabel = label || DEFAULT_LABEL;
    const resolvedTestIdBase = testIdBase || DEFAULT_TESTID_BASE;

    const handleClick = () => {
        if (onClick) {
            onClick();
            return;
        }
        if (api && api.clickEndTurn) api.clickEndTurn();
    };

    const variant = gamePlayerData
        ? VARIANTS[gamePlayerData.faction] : null;
    const containerClass = extraClass
        ? 'action-done-container ' + extraClass
        : 'action-done-container';

    return (
        <div className={containerClass}
             data-testid={resolvedTestIdBase + '-container'}>
            <Button variant={variant}
                    className={'action-done-button'}
                    data-testid={resolvedTestIdBase + '-button'}
                    onClick={handleClick}>
                {resolvedLabel}
            </Button>
            <img src={blank1080} alt={'done-button'}
                 onClick={handleClick}
                 className={'big-button-image'}/>
        </div>
    );
}

export default EndTurnButton;
